import type { TranslationKeys } from '../types';

export const trTR: TranslationKeys = {
  // Home page
  'home.title': 'Yapay Zeka destekli Toplantı Platformu',
  'home.createMeeting': 'Yeni Toplantı Oluştur',
  'home.creating': 'Oluşturuluyor...',
  'home.or': 'veya',
  'home.joinPlaceholder': 'Kod veya linki gir',
  'home.join': 'Katıl',
  'home.errorDefault': 'Bir hata oluştu',
  'home.meetingCreateFailed': 'Toplantı oluşturulamadı',
  'home.poweredBy': 'Powered by',

  // Join page
  'join.unableToJoin': 'Toplantıya Katılamıyorsunuz',
  'join.tryAgain': 'Tekrar Dene',
  'join.creatingSession': 'Yeni oturum oluşturuluyor...',
  'join.joiningMeeting': 'Toplantıya katılınıyor...',
  'join.loadingInfo': 'Toplantı bilgileri yükleniyor...',
  'join.failedToJoin': 'Toplantıya katılamadı',
  'join.unexpectedError': 'Beklenmeyen bir hata oluştu',
  'join.encounteredError': 'Beklenmeyen bir hata oluştu: {message}',
  'join.meetingDetails': 'Toplantı Detayları',
  'join.ok': 'Tamam',
  'join.cameraUnavailable': 'Kamera kullanılamıyor, başka bir uygulama kullanıyor olabilir.',
  'join.micUnavailable': 'Mikrofon kullanılamıyor, başka bir uygulama kullanıyor olabilir.',
  'join.mediaDeviceError': 'Medya cihazı hatası: {message}',

  // PreJoin
  'prejoin.joinLabel': 'Toplantıya Katıl',
  'prejoin.userLabel': 'Kullanıcı Adı',
  'prejoin.micLabel': 'Mikrofon',
  'prejoin.camLabel': 'Kamera',

  // Settings menu
  'settings.mediaDevices': 'Medya Cihazları',
  'settings.recording': 'Kayıt',
  'settings.camera': 'Kamera',
  'settings.microphone': 'Mikrofon',
  'settings.speakerHeadphones': 'Hoparlör & Kulaklık',
  'settings.audioOutput': 'Ses Çıkışı',
  'settings.recordMeeting': 'Toplantı Kaydı',
  'settings.meetingRecording': 'Toplantı kaydediliyor',
  'settings.noActiveRecordings': 'Bu toplantı için aktif kayıt yok',
  'settings.startRecording': 'Kaydı Başlat',
  'settings.stopRecording': 'Kaydı Durdur',
  'settings.close': 'Kapat',

  // Control bar
  'controls.microphone': 'Mikrofon',
  'controls.camera': 'Kamera',
  'controls.leave': 'Ayrıl',
  'controls.chat': 'Sohbet',
  'controls.shareScreen': 'Ekranı paylaş',
  'controls.stopScreenShare': 'Paylaşımı durdur',
  'controls.settings': 'Ayarlar',
  'controls.pause': 'Görüşmeyi Beklet',
  'controls.allowAudio': 'Sesi Etkinleştir',

  // Chat panel
  'chat.title': 'Mesajlar',
  'chat.placeholder': 'Bir mesaj yazın...',
  'chat.send': 'Gönder',
  'chat.close': 'Sohbeti kapat',

  // Connection state toast
  'connection.connecting': 'Bağlanılıyor',
  'connection.reconnecting': 'Yeniden bağlanılıyor',
  'connection.disconnected': 'Bağlantı kesildi',

  // Participant tile
  'participant.screenShareSuffix': ' – ekranı',

  // Question panel
  'question.speakAnswer': 'Lütfen sözlü olarak yanıt verin',

  // Pause overlay
  'pause.title': 'Görüşmeyi duraklattınız',
  'pause.description': 'Hazır olduğunuzda kaldığınız yerden devam edebilirsiniz.',
  'pause.resume': 'Görüşmeye devam et',
  'pause.failed': 'Görüşme duraklatılamadı. Lütfen tekrar deneyin.',
  'pause.resumeFailed': 'Görüşme devam ettirilemedi. Lütfen tekrar deneyin.',
  'pause.pausing': 'Görüşme bekletiliyor...',
  'pause.resuming': 'Görüşmeye devam ediliyor...',
  'pause.waitingAgent': '{name} bekleniyor...',
  'pause.agentFallback': 'Asistan',

  // Common
  'common.processing': 'İşleniyor...',
  'common.close': 'Kapat',
  'common.download': 'İndir',
  'common.image': 'Görsel',
  'common.previousTab': 'Önceki sekme',
  'common.nextTab': 'Sonraki sekme',

  // Content panel
  'content.openPdf': "PDF'i Aç",
  'content.pdfHint': 'PDF yeni sekmede açılacaktır',
  'content.loadingPdf': 'PDF yükleniyor...',
  'content.loadingImage': 'Görsel yükleniyor...',
  'content.imageLoadFailed': 'Görsel yüklenemedi. İndirme butonunu kullanın.',
  'content.clickDownload': 'Açmak için indirme butonuna tıklayın',
  'content.document': 'Doküman',
  'content.text': 'Metin',
  'content.tabQuestion': 'SORU',
  'content.tabText': 'METİN',
  'content.tabFile': 'DOSYA',
  'content.badgeImage': 'GÖRSEL',
  'content.badgeFile': 'DOSYA',

  // Presentation panel
  'presentation.loading': 'Sunum yükleniyor…',
  'presentation.loadingDetail': 'markdown: {count} karakter',
  'presentation.initFailed': 'Sunum başlatılamadı',

  // Mermaid diagram
  'diagram.loading': 'Diyagram yükleniyor...',
  'diagram.syntaxError': 'Diyagram söz dizimi hatası',
  'diagram.renderFailed': 'Diyagram oluşturulamadı',

  // Public slide preview page
  'preview.apiUrlMissing': 'API adresi yapılandırılmamış',
  'preview.loadFailed': 'Sunum yüklenemedi',
  'preview.loading': 'Yükleniyor…',

  // Settings menu
  'settings.backgroundEffects': 'Arka Plan Efektleri',
  'settings.backgroundNone': 'Yok',
  'settings.backgroundBlur': 'Bulanıklaştır',
  'settings.backgroundDesk': 'Çalışma Masası',
  'settings.backgroundNature': 'Doğa',
  'settings.enableNoiseCancellation': 'Gelişmiş Gürültü Engellemeyi Aç',
  'settings.disableNoiseCancellation': 'Gelişmiş Gürültü Engellemeyi Kapat',
  'settings.recordingNoEndpoint': 'Kayıt adresi tanımlanmamış',
  'settings.recordingEncryptedUnsupported': 'Şifreli toplantıların kaydı şu anda desteklenmiyor',
  'settings.recordingInProgress': 'Bu toplantı kaydediliyor',

  // Sent to the AI agent
  'agent.questionDismissed':
    '[Kullanıcı soru penceresini yanıtlamadan kapattı, doğal bir şekilde devam et]',
};
